import React, { Component } from 'react'
import '../../css/main-components/bubbles.css'

export default class InfoBubbles extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			index: this.props.index
		};
	}
	
	clickLeftBubble(index){
		index -= 1;
		
		if( index === 0 ){
			index = 6
		} else if( index === 5 ){
			index = 4
		} 
		
		this.setState({
			index: index
		});
	}
	
	clickRightBubble(index){
		index += 1;
		
		if( index === 5 ){
			index = 6
		} else if( index === 7 ){
			index = 1
		} 
		
		this.setState({
			index: index
		});
	}
	
	render(){
		
	var imgCarrousel = [1,2,3,4,5];
	
	return (
		<div id="info-bubbles">
			<div id="bubble-info">
				<div className="text">
					<span>{this.props.info.bubbles[this.state.index]}</span>
				</div>
			</div>
			<div id="bubble-logo">
				<img 
					src={`img/resources/BURBUJA-${this.props.info.icon}`}
					alt="icon"
				/>
			</div>
			<div id="bubble-photo">
				<img 
					src={`img/${this.props.section}/0${this.state.index === 6 
						? 5 : this.state.index}.jpg`}
					alt="backgroundImg"
				/>
			</div>
			<div id="bubble-buttons">
				<img
					onClick={() => this.clickLeftBubble(this.state.index)}
					src={`img/resources/BOTON-MOVILT-LEFT.png`}
					alt="button-left"
				/>
				<img
					onClick={() => this.clickRightBubble(this.state.index)}
					src={`img/resources/BOTON-MOVILT-RIGHT.png`}
					alt="button-right"
					className="button-right"
				/>
			</div>
		</div>
	)}
}



// WEBPACK FOOTER //
// ./src/components/main-components/bubbles.js